import ReactDOM from 'react-dom/client';
import { createRoot } from 'react-dom/client';
import { Popup, Button } from 'antd-mobile';
//全局只能存在一个弹窗时使用
import './modal.scss';

// 存储多模态学习 Modal 的 root 对象，避免重复创建
const multimodalRootMap = new Map();

//针对聊天页面的弹窗
export const insertModal = (element, containerId = 'agent-modal', targetId = 'grt-chat-box') => {
    // let insertToDom = document.getElementById(targetId);
    let insertToDom = document.body;
    let container = document.getElementById(containerId);
    if (!container) {
        container = document.createElement('div');
        container.id = containerId;
    }

    insertToDom.appendChild(container);
    const root = ReactDOM.createRoot(container);

    root.render(element);
};
export const removeModal = (containerId = 'agent-modal', targetId = 'grt-chat-box') => {
    let insertToDom = document.body;
    let container = document.getElementById(containerId);
    if (container) {
        insertToDom.removeChild(container);
    }
};

// 关闭 Popup
// 封装 Popup 方法
export const showPopup = (content, options = {}, popupName) => {
    let targetPopup = popupName || 'popupRoot';
    let targetContainer = `${targetPopup}Box`;
    // 如果已经有 Popup 显示，先关闭
    if (window[targetPopup]) {
        console.log('if');
        hidePopup();
    }

    // 创建容器
    window[targetContainer] = document.createElement('div');
    document.body.appendChild(window[targetContainer]);

    // 使用新的 createRoot API
    window[targetPopup] = createRoot(window[targetContainer]);

    // 渲染 Popup
    window[targetPopup].render(
        <Popup
            bodyStyle={{
                borderTopLeftRadius: '15px',
                borderTopRightRadius: '15px',
                minHeight: '40vh'
            }}
            visible={true}
            getContainer={null}
            onMaskClick={() => {
                hidePopup(targetPopup);
            }}
            {...options}
        >
            {content}
        </Popup>
    );
};

// 关闭 Popup
export const hidePopup = (popupName) => {
    let targetPopup = popupName || 'popupRoot';
    let targetContainer = `${targetPopup}Box`;
    if (window[targetPopup]) {
        // 使用新的 unmount 方法
        window[targetPopup].unmount();
        document.body.removeChild(window[targetContainer]);
        window[targetPopup] = null;
        window[targetContainer] = null;
    }
};

// 插入多模态学习 Modal（复用 root，避免重复创建警告）
export const insertMultimodalModal = (element, containerId = 'multimodal-detail-drawer') => {
    // 尽可能将抽屉插入到聊天页面的内容容器内，保证它作为页面子节点存在（而不是直接挂到 body）

    let insertToDom = (document.getElementById('grt-chat-box') && document.getElementById('grt-chat-box').querySelector('.chat-content')) ||
        document.querySelector('.chat_right_MuXNq') ||
        document.querySelector('[class*="chat_right"]') ||
        document.getElementById('grt-chat-box') ||
        document.body;
    let container = document.getElementById(containerId);
    let root = multimodalRootMap.get(containerId);

    // 如果容器不存在，创建新容器
    if (!container) {
        container = document.createElement('div');
        container.id = containerId;
        insertToDom.appendChild(container);
        // 如果插入到非 body 的父容器（如 chat_right），标记容器以便应用不同的定位样式
        if (insertToDom !== document.body) {
            container.classList.add('in-parent');
        } else {
            container.classList.remove('in-parent');
        }
        // 如果插入到聊天容器内，通知页面打开详情面板（用于触发布局收缩）
        try {
            const chatBox = document.getElementById('grt-chat-box');
            if (chatBox) {
                chatBox.setAttribute('data-detail-panel-open', 'true');
            }
        } catch (e) {
            /* ignore */
        }
    } else {
        // 如果容器已存在但不在正确的父容器中，移动到正确位置
        const currentParent = container.parentElement;
        if (currentParent !== insertToDom) {
            // 只有在 insertToDom 是 DOM 元素时才移动
            if (insertToDom !== document.body && insertToDom.contains) {
                insertToDom.appendChild(container);
                container.classList.add('in-parent');
            }
        }
    }

    // 如果 root 不存在，创建新 root 并缓存
    if (!root) {
        root = ReactDOM.createRoot(container);
        multimodalRootMap.set(containerId, root);
    }

    // 使用已存在的 root 进行渲染
    root.render(element);
};

// 移除多模态学习 Modal
export const removeMultimodalModal = (containerId = 'multimodal-detail-drawer') => {
    let container = document.getElementById(containerId);
    let root = multimodalRootMap.get(containerId);

    // 如果存在 root，先卸载
    if (root) {
        root.unmount();
        multimodalRootMap.delete(containerId);
    }

    // 移除容器（从实际父节点移除，而不是假设在 document.body 中）
    if (container && container.parentNode) {
        // 如果 container 是插入到聊天容器内，恢复聊天容器的 data-detail-panel-open 状态
        try {
            const chatBox = document.getElementById('grt-chat-box');
            if (chatBox) {
                chatBox.setAttribute('data-detail-panel-open', 'false');
            }
        } catch (e) {
            /* ignore */
        }
        container.parentNode.removeChild(container);
    }
};
